import Vue from "vue";
import Buefy from "buefy";
import Banners from "./App.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(Banners)

if(document.getElementById("homeBannersApp")){
    new Vue({
        render:h=>h(Banners,{
            props:{
                dataUrl:document.getElementById("homeBannersApp")
                    .getAttribute("dataUrl")
            }
        })
    }).$mount("#homeBannersApp")
}